import { render, staticRenderFns } from "./bulletBox.vue?vue&type=template&id=5ea327fe&"
import script from "./bulletBox.vue?vue&type=script&lang=js&"
export * from "./bulletBox.vue?vue&type=script&lang=js&"
import style0 from "./bulletBox.vue?vue&type=style&index=0&id=5ea327fe&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports